import React, {useState,useEffect} from 'react';
//import Menu from '../../components/Menu';
import Header from '../../../components/Header';
import Footer from '../../../components/MFooter'
import Loading from '../../../components/Loading'
import {Error} from '../../../components/Erro'
import useFind from '../../../hooks/useFind'
import useForm from '../../../hooks/useForm'
import {sortModos,sortGenerico} from '../../../utils/djSort'

// import './supervisorio.css'
import './djtable.css'
function Home () {

  return (
    <div>
      <Header/>

      {/*Conteudo*/}
      <Corpo/>
      {/* {bloco_alunos} */}
      {/*
      */}
      <Footer/>
    </div>
  );
}

export default Home;


function Corpo({municipiosAtt}){

    const { values, handleChange} = useForm({
            municipio:'',
            m:'São Luís'
    })

    const [municipios, setMunicipios] = useState([
        'São Luís'
    ])
    //const [loading, setLoading] = useState(true);

    function Option ({nome}){
        return (
            <option value={nome}>{nome}</option>
        )
    }

    const busca = (!!values.municipio&&values.municipio!=='') ? 'municipio='+values.municipio : ""

    const {data, isLoading, error} = useFind('/supervisorio?'+busca)

    console.log('values.municipio',values.municipio,municipios)
    function pre_loading(){
        // console.log('data',{data})
        if (!isLoading){
            const {alunos} = data;
            alunos.forEach(user=>{
                if (!municipios.includes(user.municipio)){
                    setMunicipios(municipios.concat([user.municipio]))
                }
            })
        }
    }
    useEffect(pre_loading,[values.municipio,isLoading,data,municipios])

    // api.get
    if (isLoading){
        return <Loading/>
    }
    if (!!error){
        console.error(error.messages)
        return <Error error={error.messages}/>
    }



    return (<div className='supervisorio'>

        <div className="form-group form-icon">
            <label className="form-label">Escolha um município</label>
            <select name="municipio" required
                value={values.municipio}
                onChange={handleChange}
                // className = {values.municipio!=="Outro"? "form-input" : ""}
            >
                <option value='' >Todos</option>
                {/* <option value='' >Todos</option> */}
                {municipios.map((nome,i)=><Option key={`k_${i}_${nome}`} nome ={nome}/>)}
                {/* <option value="out">Outro</option> */}
            </select>
        </div>

        {/* <ListaAlunos alunos={alunos} mundos={mundos}/> */}
        <p style={{'font-size': '1.9rem', margin:'10px'}} >{`Sua pesquisa retornou ${data.alunos.length} alunos listados`}</p>

        <Tabela alunos={data.alunos} mundos={data.mundos} busca={busca}/>

    </div>)

}

function Tabela({alunos, mundos,busca}){
    const [estadoSort,setEstadoSort] = useState({
        modo:'ID',
        stts:0
    })
    const btns_data = {estadoSort, setEstadoSort}


    return (<div style={{display: "flex", "justifyContent": "center"}}>
        <table style={{width:"90vw"}} className="tb-teste">
            <thead>
                <tr style={{fontSize:"2rem"}}>
                    <th>Nº</th>
                    <th className="celula c_id">ID <Botao name={'ID'} {...btns_data}/></th>
                    <th className="celula c_nome">NOME <Botao name={'NOME'} {...btns_data}/></th>
                    <th className="celula c_pontos">PONTOS <Botao name={'PONTOS'} {...btns_data}/></th>
                    <th className="celula c_mundos">MARCOS <Botao name={'MARCOS'} {...btns_data}/></th>
                    <th className="celula c_btns">Painel <Botao name={'Painel'} {...btns_data}/></th>
                    {busca===""&&<th className="celula c_mun">Municipio <Botao name={'MUNICIPIO'} {...btns_data}/></th>}
                </tr>
            </thead>
            <div style={{height: "10px"}}/>

            <ListaAlunos alunos={alunos} mundos={mundos} {...btns_data} busca={busca}/>

            {/* <tbody style={{fontSize:"2rem"}} >
                <tr>
                    <th>1</th>
                    <td>28</td>
                    <td>Luis Eduardo</td>
                    <td>100</td>
                    <td>MARCOS</td>
                    <td></td>
                </tr>
                <tr>
                    <th>1</th>
                    <td>28</td>
                    <td>Luis Eduardo</td>
                    <td>100</td>
                    <td>MARCOS</td>
                    <td></td>
                </tr>
            </tbody> */}
        </table>

    </div>)
}

function ListaAlunos({alunos,mundos,estadoSort, setEstadoSort,busca}){

    const _alunos = estadoSort.stts===0?alunos : alunos.sort(sortModos_Mock[estadoSort.modo][estadoSort.stts-1]);

    return (
        <tbody style={{fontSize:"2rem"}}>
            {_alunos.map((aluno,p)=>
                <BlocoAlunos position={p} key={aluno.id} aluno={aluno} mundos={mundos} busca={busca}/>
            )}
        </tbody>
    )

}


function BlocoAlunos(props){
    const {aluno, mundos, position,busca} = props
    const painel = <></>
    // const painel = (<>
    //     <div>Atualizar turma</div>
    //     <div>Ver mais detalhes</div>
    //     <div>b3</div>
    //     <div>b4</div>
    // </>)

    function iconeMundo(id){
        const mundo = mundos.find(m=>m.id===id)
        const src = process.env.PUBLIC_URL+"/img/mundos_logo/"+mundo.icone
        // className="mundos-icon"
        const txt = `Concluiu o marco: ${mundo.titulo}.`
        return <img key={mundo.titulo} alt={txt} title={txt} src={src}/>
    }

    const aluno_mundos = aluno.mundos.sort(sortModos.POSICAO_CRESCENTE).map(mundo=>iconeMundo(mundo.id))

    return (
        <tr>
            <th className = " a_p"> {`${position+1}°`}</th>
            <td className = "celula a_id"> {aluno.id}</td>
            {/* <td> <div className = "celula a_nome">  {aluno.nome}</div></td> */}
            <td className = "celula a_nome"> {aluno.nome}</td>
            <td className = "celula c_pontos"> {aluno.pontos}</td>
            <td className = "celula a_mundos"> {aluno_mundos}</td>
            <td className = "celula a_btns"> {painel}</td>
            {busca===""&&<td className="celula a_mun">{aluno.municipio}</td>}

        </tr>
    )
}


//
// <div className="grid-container">
//   <div className="ID">ID</div>
//   <div className="nome">NOME</div>
//   <div className="Mundos">MUNDOS</div>
//   <div className="btns">BOTÃOS</div>
//
// </div>
//
// <div className="grid-container">
//   <div className="a_id">A_ID</div>
//   <div className="a_nome">A_NOME NOME NOME</div>
//   <div className="a_mundos">A_MUNDOS</div>
//   <div className="a_btns">A_MUNDOS</div>
//
// </div>


function Botao({name,estadoSort,setEstadoSort}){
    const stts = estadoSort.modo===name? estadoSort.stts : 0;
    console.group()
    console.log('stts',stts)
    console.log('estadoSort',estadoSort)
    console.groupEnd()
    const onClick = async ()=>await setEstadoSort({modo:name,stts:(stts+1)%3})
    const textos = TextoModos[name]
    if (stts===1)
        return  <i className='djbtn sort-btn fi-br-caret-up' onClick={onClick} title={textos[1]}/>
    if (stts===2)
        return  <i className='djbtn sort-btn fi-br-caret-down'   onClick={onClick} title={textos[2]}/>
    // if (!stts || stts===0)
    return      <i className='djbtn sort-btn fi-rr-apps-sort'  onClick={onClick} title={textos?.[0]}/>
}

const sortModos_Mock ={
    ID:[sortGenerico.CRESCENTE(x=>x.id),sortGenerico.DECRESCENTE(x=>x.id)],
    NOME:[sortGenerico.ALFA(x=>x.nome),sortGenerico.ALFA_R(x=>x.nome)],
    PONTOS:[sortGenerico.CRESCENTE(x=>x.pontos),sortGenerico.DECRESCENTE(x=>x.pontos)],
    MARCOS:[sortGenerico.CRESCENTE(x=>x.mundos.length),sortGenerico.DECRESCENTE(x=>x.mundos.length)],
    MUNICIPIO:[sortGenerico.ALFA(x=>x.municipio),sortGenerico.ALFA_R(x=>x.municipio)],
}
const TextoModos ={
    ID:["Clique para organizar","ID por ordem crescente","ID por ordem decrescente"],
    NOME:["Clique para organizar","Nome por ordem Alfabética","Nome por ordem Alfabética Invertida"],
    PONTOS:["Clique para organizar","Ordem crescente de pontos","Ordem decrescente de pontos"],
    MARCOS:["Clique para organizar","Maior quantidade de marcos concluidos","Menor quantidade de marcos concluidos"],
    MUNICIPIO:["Clique para organizar","Nome por ordem Alfabética","Nome por ordem Alfabética Invertida"],
}
